export default "__VITE_ASSET__DXnqISv1__"